import { FC, useCallback } from "react";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureGenerateDiagramDisabledSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureGenerateDiagramDisabledSelector";
import { generateInfrastructureArchitectureThunk } from "@/store/infrastructure-architecture/thunks/generateInfrastructureArchitectureThunk";
import { infrastructureArchitecturePossibleServicesRegionsLoadingSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitecturePossibleServicesRegionsLoadingSelector";
import { setInfrastructureArchitectureRequestData } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";

export const InfrastructureArchitectureGenerateDiagramButton: FC = () => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(
    infrastructureArchitectureGenerateDiagramDisabledSelector,
  );

  const possibleRegionsAndServicesLoading = useAppSelector(
    infrastructureArchitecturePossibleServicesRegionsLoadingSelector,
  );

  const clickHandler = useCallback(() => {
    dispatch(
      setInfrastructureArchitectureRequestData({
        selectedArchitectureId: undefined,
      }),
    );
    dispatch(generateInfrastructureArchitectureThunk());
  }, [dispatch]);

  return (
    <LoadingButton
      variant="contained"
      onClick={clickHandler}
      disabled={disabled || possibleRegionsAndServicesLoading}
    >
      Generate Diagram
    </LoadingButton>
  );
};
